var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Triangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Copy-7",
    transform: "translate(-49.000000, -351.000000)",
    stroke: "#3E3E3E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0396539,354.451214 C56.3805267,354.380875 56.7482329,354.440575 57.0619768,354.646986 C57.2166456,354.748741 57.3489098,354.881006 57.4506656,355.035674 L57.4506656,355.035674 L63.0480068,363.543633 C63.2544173,363.857377 63.3141171,364.225083 63.2437782,364.565956 C63.1734394,364.906829 62.973062,365.220868 62.659318,365.427279 C62.4373696,365.573297 62.1775134,365.651112 61.9118396,365.651112 L61.9118396,365.651112 L50.7171571,365.651112 C50.3416035,365.651112 50.0016035,365.498888 49.7554919,365.252777 C49.5093803,365.006665 49.3571571,364.666665 49.3571571,364.291112 C49.3571571,364.025438 49.4349712,363.765582 49.5809899,363.543633 L49.5809899,363.543633 L55.1783311,355.035674 C55.3847416,354.72193 55.6987811,354.521553 56.0396539,354.451214 Z",
    id: "Triangle",
    transform: "translate(56.314498, 359.275043) rotate(-270.000000) translate(-56.314498, -359.275043) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.840c7eaef70952c87a47ac5ead53b0eb.svg";
export { ForwardRef as ReactComponent };